import { createClient } from '@supabase/supabase-js';

const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL || 'https://hblyziyoowfhwlqihuww.supabase.co';
const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhibHl6aXlvb3dmaHdscWlodXd3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODQyMDcwOTgsImV4cCI6MjA5OTc4MzA5OH0.ZvIMF6NTXaVAalYlR9h42GAdVX4n_0XsASZl6fyg4N0';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

const SCRAP_IMAGE_BUCKET = 'scrap-images';
const MAX_SCRAP_IMAGES = 10;
const MAX_SCRAP_IMAGE_BYTES = 5 * 1024 * 1024;
const ALLOWED_SCRAP_IMAGE_TYPES = new Set([
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
  'image/gif',
  'image/heic',
  'image/heif',
]);

function safeFileName(name = 'image') {
  return name.replace(/[^a-zA-Z0-9._-]/g, '_').slice(0, 80);
}

export function isAllowedScrapImage(file) {
  if (!file) return false;
  if (file.size > MAX_SCRAP_IMAGE_BYTES) return false;
  if (ALLOWED_SCRAP_IMAGE_TYPES.has(file.type)) return true;
  return /\.(jpe?g|png|webp|gif|heic|heif)$/i.test(file.name || '');
}

export async function uploadScrapImages(files = []) {
  const selected = Array.from(files || [])
    .filter(isAllowedScrapImage)
    .slice(0, MAX_SCRAP_IMAGES);

  const urls = [];

  for (const file of selected) {
    const path = `posts/${Date.now()}-${Math.random().toString(36).slice(2, 8)}-${safeFileName(file.name)}`;
    const { error } = await supabase.storage.from(SCRAP_IMAGE_BUCKET).upload(path, file, {
      cacheControl: '3600',
      upsert: false,
      contentType: file.type || 'image/jpeg',
    });

    if (error) throw error;

    const { data } = supabase.storage.from(SCRAP_IMAGE_BUCKET).getPublicUrl(path);
    if (data?.publicUrl) urls.push(data.publicUrl);
  }

  return urls;
}

export async function createScrapPost(payload) {
  const { data, error } = await supabase
    .from('scrap_posts')
    .insert(payload)
    .select('id, reference_number, status')
    .single();

  if (error) throw error;
  return data;
}

export async function createCollectorEnquiry(payload) {
  const { data, error } = await supabase
    .from('collector_enquiries')
    .insert(payload)
    .select('id')
    .single();

  if (error) throw error;
  return data;
}

export { MAX_SCRAP_IMAGES, MAX_SCRAP_IMAGE_BYTES };
